export interface EcommerceItem {
  item_id: string
  item_name: string
  item_category?: string
  item_variant?: string
  price?: number
  quantity?: number
  item_brand?: string
  item_list_name?: string
}

export interface EcommercePayload {
  currency?: string
  value?: number
  items: EcommerceItem[]
}

declare global {
  interface Window {
    dataLayer?: unknown[]
  }
}

const DEFAULT_CURRENCY = 'USD'

const ensureDataLayer = (): unknown[] | null => {
  if (typeof window === 'undefined') return null
  window.dataLayer = window.dataLayer || []
  return window.dataLayer
}

export const pushDataLayerEvent = (
  eventName: string,
  payload?: Record<string, unknown>
): void => {
  const dataLayer = ensureDataLayer()
  if (!dataLayer) return

  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: eventName,
    ...(payload ?? {}),
  })
}

interface TrackCommerceEventInput {
  value: number
  size: string
  quantity?: number
  itemId?: string
  itemName?: string
  boardId?: string
}

const buildDefaultItem = ({
  value,
  size,
  quantity = 1,
  boardId,
  itemId = 'printboard-custom-print',
  itemName = 'Custom Vision Board Print',
}: TrackCommerceEventInput): EcommerceItem => ({
  item_id: itemId,
  item_name: itemName,
  item_brand: 'Printboard',
  item_category: 'prints',
  item_variant: size,
  item_list_name: boardId ? `board:${boardId}` : undefined,
  price: value,
  quantity,
})

export const trackViewItem = (input: TrackCommerceEventInput): void => {
  pushDataLayerEvent('view_item', {
    ecommerce: {
      currency: DEFAULT_CURRENCY,
      value: input.value,
      items: [buildDefaultItem(input)],
    } satisfies EcommercePayload,
  })
}

export const trackBeginCheckout = (input: TrackCommerceEventInput): void => {
  pushDataLayerEvent('begin_checkout', {
    ecommerce: {
      currency: DEFAULT_CURRENCY,
      value: input.value,
      items: [buildDefaultItem(input)],
    } satisfies EcommercePayload,
  })
}
